module.exports = __webpack_public_path__ + "media/images/pause-profile-cc4d42452c6be1b8b4f066ee69c767d8.png";